import { Box, Divider, Tab, Tabs } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import {
    Championship,
    Collections,
    RaceControl,
    Track,
    useCollection,
    useRound,
} from "api";
import { DateTime } from "luxon";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { BoxCard, PageLayout, Subtitle, Title } from "ui/componentes";
import { RaceControlForm } from "ui/views/ChampionshipForm/RoundEdit/RaceControlForm";
import { StartRoundButton } from "ui/views/ChampionshipForm/RoundEdit/StartRoundButton";

const selectRaceTab = (setSelectedRace) => (event, value) =>
    setSelectedRace(value);

const RoundEdit = () => {
    const { id } = useParams<{ id }>();

    const tracksById =
        useCollection<{ [key: string]: Track }>({
            collection: Collections.TRACKS,
        }) || {};

    const { round, loading } = useRound({
        roundId: id,
        withRaces: true,
        withRacesControl: true,
    });

    const championship = useCollection<Championship>({
        collection: Collections.CHAMPIONSHIPS,
        doc: round ? round.championshipId : "-1",
    });

    const [hasRaceConfiguration, setHasRaceConfiguration] = useState(false);
    const [hasRaces, setHasRaces] = useState(false);
    const [roundDate, setRoundDate] = useState("");
    const [selectedRace, setSelectedRace] = useState(1);
    const selectedRaceControl = useMemo<RaceControl>(() => {
        if (round.races && round.races.length > 0) {
            const races = round.races.filter(
                (race) => race.raceNumber === selectedRace
            );
            if (races && races.length > 0) {
                return races[0].raceControl || {};
            }
        }
        return {};
    }, [selectedRace, round]);

    useEffect(() => {
        if (championship) {
            setHasRaceConfiguration(
                championship.raceConfigurations &&
                    championship.raceConfigurations.length > 0
            );
        }
    }, [championship]);

    useEffect(() => {
        if (round) {
            setRoundDate(DateTime.fromISO(round.date).toFormat("dd/MM/yyyy"));

            if (round.races && round.races.length > 0) {
                setHasRaces(true);
            } else {
                setHasRaces(false);
            }
        }
    }, [round]);

    return (
        <PageLayout title="" showInBoxCard={false}>
            <Box display="flex" flexDirection="column" height="100%">
                <Box display="flex" justifyContent="space-around">
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-around"
                        minWidth={210}
                        padding={2}
                    >
                        <Subtitle text="Campeonato" color="textSecondary" />
                        <Divider />
                        <Title
                            text={championship?.name}
                            color="textSecondary"
                        />
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        minWidth={210}
                        padding={2}
                    >
                        <Subtitle text={`Etapa`} color="textSecondary" />
                        <Divider />
                        <Title
                            text={tracksById[round.trackId]?.friendlyName}
                            color="textSecondary"
                        />
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        minWidth={210}
                        padding={2}
                    >
                        <Subtitle text="Data" color="textSecondary" />
                        <Divider />
                        <Title text={roundDate} color="textSecondary" />
                    </Box>
                </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    width="100%"
                    height="100%"
                >
                    <Box
                        id="editContent"
                        display="flex"
                        flexDirection="column"
                        alignContent="center"
                        width="90%"
                    >
                        {hasRaces && (
                            <>
                                <BoxCard
                                    id="tabs"
                                    style={{ marginTop: 24 }}
                                    padding={0}
                                >
                                    <Tabs
                                        variant="fullWidth"
                                        centered
                                        indicatorColor="primary"
                                        textColor="primary"
                                        value={selectedRace}
                                        onChange={selectRaceTab(
                                            setSelectedRace
                                        )}
                                        style={{ flexGrow: 1 }}
                                    >
                                        {round.races
                                            ?.sort(
                                                (r1, r2) =>
                                                    r1.raceNumber -
                                                    r2.raceNumber
                                            )
                                            .map(({ raceNumber }) => {
                                                return (
                                                    <Tab
                                                        key={`bateria_${raceNumber}`}
                                                        label={`Bateria ${raceNumber}`}
                                                        value={raceNumber}
                                                    />
                                                );
                                            })}
                                    </Tabs>
                                </BoxCard>
                                <RaceControlForm
                                    championship={championship}
                                    raceControl={selectedRaceControl}
                                />
                            </>
                        )}
                        {hasRaceConfiguration && !hasRaces && (
                            <StartRoundButton
                                roundId={id}
                                championshipId={championship.id || ""}
                                raceConfigurations={
                                    championship.raceConfigurations
                                }
                            />
                        )}

                        {!loading && championship && !hasRaceConfiguration && (
                            <Box
                                width="100%"
                                height="100%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Alert
                                    severity="info"
                                    variant="outlined"
                                    style={{ fontSize: 24 }}
                                >
                                    Não há configurações de baterias para este
                                    campeonato
                                </Alert>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </PageLayout>
    );
};

export { RoundEdit };
